import {
  BorderBox,
  Box,
  Button,
  FlexBox,
  Heading,
  Rhythm,
  TextSmall,
} from '@trmediaab/zebra';
import { Html } from '@trmediaab/zebra-components';
import type { Campaign, Product } from '@trmediaab/zebra-types/trhub';
import { cloudinary } from '@trmediaab/zebra-utils';
import { useCallback } from 'react';

import parseProduct from '../utils/parseProduct';
import Price from './Price';

const vnrCdnId = 'uploads/l9t2jjgfplq3nxqtndse';

interface VinternumretProductProps {
  product: Product;
  campaigns: Campaign[];
  onProductSelected: (product: Product) => void;
  onCampaignSelected: (campaign: Campaign) => void;
}

const VinternumretProduct = ({
  product,
  campaigns,
  onProductSelected,
  onCampaignSelected,
}: VinternumretProductProps) => {
  const { headline, description, terms, price, reducedPrice, campaign } =
    parseProduct(product, campaigns);

  const onClick = useCallback(() => {
    if (campaign != null) {
      onCampaignSelected(campaign);
    } else {
      onProductSelected(product);
    }
  }, [campaign, onCampaignSelected, onProductSelected, product]);

  return (
    <BorderBox border="1" bg="#252E41" boxShadow="offersPage.productBox">
      <FlexBox flexDirection={['column', null, 'row']}>
        <Rhythm
          between="3"
          color="white"
          width={['100%', null, '65%', '65%']}
          p={[4, null, '4,5']}
          sx={{
            textAlign: ['center', null, 'left'],
          }}
          maxWidth={['320px', null, 'none']}
          mx="auto"
        >
          <Heading.h2
            variant="none"
            fontSize={[3, null, 5]}
            lineHeight="medium"
            fontWeight="bold"
            mb="2"
          >
            Köp {headline}
          </Heading.h2>
          <Html
            between="2"
            variant="checkoutRegular"
            html={description}
            maxWidth="640px"
          />
          <Price price={price} reducedPrice={reducedPrice} center={false} />
          <TextSmall
            fontWeight="normal"
            lineHeight="medium"
            color="white"
            maxWidth="640px"
          >
            {terms} I nästa steg kan du välja antal och även beställa tidningen
            utomlands
          </TextSmall>
          <Box>
            <Button
              bc="offersPrimary"
              onClick={onClick}
              data-no-between="true"
              mt="3,5"
              width={['100%', null, 'auto']}
            >
              Köp vinternumret
            </Button>
          </Box>
        </Rhythm>
        <Box
          order={[-1, null, 'initial']}
          width={['100%', null, '35%', '50%']}
          mt={-3}
          pr={[null, null, '4,5']}
        >
          <BorderBox
            as="img"
            mx="auto"
            maxHeight="360px"
            height="auto"
            boxShadow="0px 0px 8px 0 rgba(34, 34, 34, 0.15)"
            src={cloudinary.getUrl(vnrCdnId, 540)}
            alt="Vinternumret omslag"
          />
        </Box>
      </FlexBox>
    </BorderBox>
  );
};

export default VinternumretProduct;
